<div class="tw-w-full tw-h-full tw-min-h-[100vh] tw-bg-background">
  <div class="tw-w-full tw-h-full tw-min-h-[100vh] tw-flex tw-flex-col tw-justify-center tw-items-center">
    <app-steps [steps]="steps" [(currentStep)]="currentStep"></app-steps>
    <div
      *ngIf="currentStep && currentStep.id == steps[0].id"
      class="max-md:tw-flex-1 tw-min-w-full tw-max-w-full md:tw-min-w-[600px] md:tw-max-w-[600px] tw-h-fit tw-bg-secondary md:tw-rounded-[10px] tw-p-4"
    >
      <div (click)="goBack()" class="tw-w-fit tw-h-fit tw-flex tw-justify-center tw-items-center tw-bg-white tw-rounded-full tw-cursor-pointer tw-p-2 tw-mb-10">
        <div class="tw-w-8 tw-h-8 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full">
          <img class="tw-w-6 tw-h-6 tw-object-contain" src="../../../assets/arrow-left.svg" />
        </div>
        <p class="tw-w-fit tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-px-5">{{ "back" | translate }}</p>
      </div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-3xl tw-text-white tw-text-center tw-mb-10">{{ "register" | translate }}</p>
      <div class="tw-w-full tw-h-fit tw-px-8 md:tw-px-28">
        <form [formGroup]="accountForm">
          <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "email" | translate }}</p>
          <input
            class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-sm tw-bg-white tw-text-secondary tw-mb-6 tw-rounded-[5px] tw-outline-none tw-px-4 tw-py-3"
            type="email"
            formControlName="email"
            placeholder="{{ 'email-placeholder' | translate }}"
          />
          <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "password" | translate }}</p>
          <div class="tw-w-full tw-h-fit tw-relative tw-flex tw-items-center tw-bg-white tw-mb-6 tw-rounded-[5px] tw-px-4 tw-py-3 tw-overflow-hidden">
            <input
              class="tw-w-full tw-h-full tw-font-poppins tw-font-normal tw-text-sm tw-text-secondary tw-outline-none tw-pr-8"
              [type]="inputType1"
              formControlName="password"
              placeholder="{{ 'enter-your-password' | translate }}"
            />
            <img (click)="showHideField(1)" class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" [src]="showHide1" />
          </div>
          <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "confirm-password" | translate }}</p>
          <div class="tw-w-full tw-h-fit tw-relative tw-flex tw-items-center tw-bg-white tw-mb-6 tw-rounded-[5px] tw-px-4 tw-py-3 tw-overflow-hidden">
            <input
              class="tw-w-full tw-h-full tw-font-poppins tw-font-normal tw-text-sm tw-text-secondary tw-outline-none tw-pr-8"
              [type]="inputType2"
              formControlName="confirmPassword"
              placeholder="{{ 'confirm-your-password' | translate }}"
            />
            <img (click)="showHideField(2)" class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" [src]="showHide2" />
          </div>
          <app-phone-input [formGroup]="accountForm" formControlName="phone" [label]="'phone' | translate" [darkBackground]="true"></app-phone-input>
        </form>
        <p *ngIf="isError" class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-white tw-mb-6">
          {{ isErrorText | translate }}
        </p>

        <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-6 tw-mb-6">
          <button (click)="continueStep1()" class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-sm tw-bg-primary tw-text-secondary tw-rounded-[5px] tw-py-3">
            {{ "continue" | translate }}
          </button>
        </div>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-text-center tw-mb-10 md:tw-mb-20">
          {{ "already-have-an-account" | translate }}
          <span (click)="goToLogin()" class="tw-text-primary tw-cursor-pointer">{{ "login" | translate }}</span>
        </p>
      </div>
    </div>
    <div
      *ngIf="currentStep && currentStep.id == steps[1].id"
      class="max-md:tw-flex-1 tw-min-w-full tw-max-w-full md:tw-min-w-[600px] md:tw-max-w-[600px] tw-h-fit tw-bg-secondary md:tw-rounded-[10px] tw-p-4"
    >
      <div (click)="goBack()" class="tw-w-fit tw-h-fit tw-flex tw-justify-center tw-items-center tw-bg-white tw-rounded-full tw-cursor-pointer tw-p-2 tw-mb-10">
        <div class="tw-w-8 tw-h-8 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full">
          <img class="tw-w-6 tw-h-6 tw-object-contain" src="../../../assets/arrow-left.svg" />
        </div>
        <p class="tw-w-fit tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-px-5">{{ "back" | translate }}</p>
      </div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-3xl tw-text-white tw-text-center tw-mb-10">{{ "register" | translate }}</p>
      <div class="tw-w-full tw-h-fit tw-px-8 md:tw-px-28">
        <form [formGroup]="locationForm">
          <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "business-display-name" | translate }}</p>
          <input
            class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-sm tw-bg-white tw-text-secondary tw-mb-6 tw-rounded-[5px] tw-outline-none tw-px-4 tw-py-3"
            type="text"
            formControlName="display_name"
            placeholder="{{ 'enter-your-business-display-name' | translate }}"
          />

          <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">{{ "business-name" | translate }}</p>
          <input
            class="tw-w-full tw-h-fit tw-font-poppins tw-font-normal tw-text-sm tw-bg-white tw-text-secondary tw-mb-6 tw-rounded-[5px] tw-outline-none tw-px-4 tw-py-3"
            type="text"
            formControlName="name"
            placeholder="{{ 'enter-your-business-name' | translate }}"
          />

          <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-mb-2">
            {{ "add-a-branch" | translate }}
            <span class="tw-text-xs tw-text-white/50">({{ "you-can-add-more-later-if-you-wish" | translate }})</span>
          </p>
          <div class="tw-w-full tw-h-52 tw-relative tw-overflow-hidden tw-rounded-[10px] tw-mb-6">
            <div id="map" class="tw-w-full tw-h-full !tw-z-[1]"></div>
            <button
              (click)="getUserLocation()"
              class="tw-w-fit tw-h-fit tw-absolute tw-bottom-8 tw-right-4 !tw-z-[99] tw-bg-tertiary hover:tw-bg-tertiary/90 active:tw-bg-tertiary/80 tw-font-poppins tw-font-semibold tw-text-xs tw-text-white tw-border tw-border-primary hover:tw-border-primary/80 tw-rounded-[5px] tw-px-2 tw-py-2 tw-shadow-lg hover:tw-shadow-xl active:tw-shadow-md tw-transition-all tw-duration-200 hover:tw-scale-105 active:tw-scale-95"
            >
              <img class="tw-w-6 tw-h-6 tw-object-contain tw-filter tw-drop-shadow-sm" src="../../../assets/user-location-marker.svg" />
            </button>
          </div>
        </form>
        <p *ngIf="isError" class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-white tw-mb-6">
          {{ isErrorText | translate }}
        </p>

        <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-6 tw-mb-6">
          <button (click)="continueStep2()" class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-sm tw-bg-primary tw-text-secondary tw-rounded-[5px] tw-py-3">
            {{ "continue" | translate }}
          </button>
        </div>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-text-center tw-mb-10 md:tw-mb-20">
          {{ "already-have-an-account" | translate }}
          <span (click)="goToLogin()" class="tw-text-primary tw-cursor-pointer">{{ "login" | translate }}</span>
        </p>
      </div>
    </div>
    <div
      *ngIf="currentStep && currentStep.id == steps[2].id"
      class="max-md:tw-flex-1 tw-min-w-full tw-max-w-full md:tw-min-w-[600px] md:tw-max-w-[600px] tw-h-fit tw-bg-secondary md:tw-rounded-[10px] tw-p-4"
    >
      <div (click)="goBack()" class="tw-w-fit tw-h-fit tw-flex tw-justify-center tw-items-center tw-bg-white tw-rounded-full tw-cursor-pointer tw-p-2 tw-mb-10">
        <div class="tw-w-8 tw-h-8 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full">
          <img class="tw-w-6 tw-h-6 tw-object-contain" src="../../../assets/arrow-left.svg" />
        </div>
        <p class="tw-w-fit tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-px-5">{{ "back" | translate }}</p>
      </div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-3xl tw-text-white tw-text-center tw-mb-10">{{ "register" | translate }}</p>
      <div class="tw-w-full tw-h-fit tw-px-8 md:tw-px-28">
        <form [formGroup]="typeForm">
          <div (click)="setSelectedType(type)" *ngFor="let type of accountTypes" class="tw-w-full tw-h-fit tw-flex tw-rounded-[10px] tw-bg-white tw-p-4 tw-mb-6">
            <input class="tw-w-7 tw-h-7 tw-self-center tw-accent-primary" type="radio" [checked]="selectedType && selectedType.id == type.id" />
            <div class="tw-flex-1 tw-flex tw-flex-col tw-px-4">
              <p class="tw-font-poppins tw-font-medium tw-text-lg tw-text-secondary tw-mb-2">
                {{ type.title | translate }}
              </p>
              <p class="tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary/50">
                {{ type.description | translate }}
              </p>
            </div>
          </div>
        </form>
        <p *ngIf="isError" class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-white tw-mb-6">
          {{ isErrorText | translate }}
        </p>

        <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-6 tw-mb-6">
          <button
            (click)="continueStep3()"
            [disabled]="disableButton"
            class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-sm tw-bg-primary tw-text-secondary tw-rounded-[5px] tw-py-3"
            [ngClass]="{ 'tw-opacity-70 tw-cursor-not-allowed': disableButton }"
          >
            {{ disableButton ? ("please-wait" | translate) : ("continue" | translate) }}
          </button>
        </div>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-text-center tw-mb-10 md:tw-mb-20">
          {{ "already-have-an-account" | translate }}
          <span (click)="goToLogin()" class="tw-text-primary tw-cursor-pointer">{{ "login" | translate }}</span>
        </p>
      </div>
    </div>
    <div
      *ngIf="currentStep && currentStep.id == steps[3].id"
      class="max-md:tw-flex-1 tw-min-w-full tw-max-w-full md:tw-min-w-[600px] md:tw-max-w-[600px] tw-h-fit tw-bg-secondary md:tw-rounded-[10px] tw-p-4"
    >
      <div (click)="goBack()" class="tw-w-fit tw-h-fit tw-flex tw-justify-center tw-items-center tw-bg-white tw-rounded-full tw-cursor-pointer tw-p-2 tw-mb-10">
        <div class="tw-w-8 tw-h-8 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full">
          <img class="tw-w-6 tw-h-6 tw-object-contain" src="../../../assets/arrow-left.svg" />
        </div>
        <p class="tw-w-fit tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary tw-px-5">{{ "back" | translate }}</p>
      </div>
      <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-3xl tw-text-white tw-text-center tw-mb-10">{{ "register" | translate }}</p>
      <div class="tw-w-full tw-h-fit tw-px-8 md:tw-px-28">
        <form [formGroup]="planForm">
          <div (click)="setSelectedPlan(plan)" *ngFor="let plan of filteredPricingPlans" class="tw-w-full tw-h-fit tw-flex tw-rounded-[10px] tw-bg-white tw-p-4 tw-mb-6">
            <input class="tw-w-7 tw-h-7 tw-self-center tw-accent-primary" type="radio" [checked]="selectedPlan && selectedPlan.id == plan.id" />
            <p class="tw-flex-1 tw-flex tw-items-center tw-font-poppins tw-font-medium tw-text-lg tw-text-secondary tw-px-4">
              {{ plan.title | translate }}
            </p>
            <div class="tw-w-fit tw-h-full">
              <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary/50">{{ "price" | translate }}:</p>
              <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary/50">
                <span class="tw-text-3xl tw-text-secondary">{{ plan.price | translate }}</span
                >{{ plan.priceTime | translate }}
              </p>
            </div>
          </div>
        </form>
        <p *ngIf="isError" class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-white tw-mb-6">
          {{ isErrorText | translate }}
        </p>

        <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-6 tw-mb-6">
          <button
            (click)="continueStep4()"
            [disabled]="disableButton"
            class="tw-w-full tw-h-fit tw-font-poppins tw-font-semibold tw-text-sm tw-bg-primary tw-text-secondary tw-rounded-[5px] tw-py-3"
            [ngClass]="{ 'tw-opacity-70 tw-cursor-not-allowed': disableButton }"
          >
            {{ disableButton ? ("please-wait" | translate) : ("continue" | translate) }}
          </button>
        </div>
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-white tw-text-center tw-mb-10 md:tw-mb-20">
          {{ "already-have-an-account" | translate }}
          <span (click)="goToLogin()" class="tw-text-primary tw-cursor-pointer">{{ "login" | translate }}</span>
        </p>
      </div>
    </div>
  </div>
</div>
